/**
 * 条件日志工具
 *
 * 生产环境下禁用 debug 级别日志，仅保留 warn 和 error
 */

const isDev = import.meta.env.DEV || import.meta.env.MODE === 'development';

type LogLevel = 'debug' | 'info' | 'warn' | 'error';

interface Logger {
  debug: (...args: unknown[]) => void;
  info: (...args: unknown[]) => void;
  warn: (...args: unknown[]) => void;
  error: (...args: unknown[]) => void;
}

function createLogger(prefix: string): Logger {
  const format = (level: LogLevel, args: unknown[]) => {
    const timestamp = new Date().toISOString().slice(11, 23);
    return [`[${timestamp}][${prefix}][${level.toUpperCase()}]`, ...args];
  };

  return {
    debug: (...args: unknown[]) => {
      if (isDev) {
        console.log(...format('debug', args));
      }
    },
    info: (...args: unknown[]) => {
      if (isDev) {
        console.log(...format('info', args));
      }
    },
    warn: (...args: unknown[]) => {
      console.warn(...format('warn', args));
    },
    error: (...args: unknown[]) => {
      console.error(...format('error', args));
    },
  };
}

// 预定义的模块日志器
export const speakingLog = createLogger('speaking');
export const llmLog = createLogger('llm');
export const syncLog = createLogger('sync');
export const dbLog = createLogger('db');
export const pwaLog = createLogger('pwa');

// 通用创建函数
export { createLogger };

// 默认日志器
export default createLogger('app');
